import React, { useContext, useEffect, useState } from 'react';
import scrollLeft from "../../Assets/Images/left-indicator-history.svg";
import scrollRight from "../../Assets/Images/right-indicator-history.svg";
import { fetchTransactionHistory } from '../../api';
import AuthContext from '../../Context/AuthContext';
import { Transcribe } from '@mui/icons-material';
import { CircularProgress, Button } from '@mui/material';

const PurchaseHistory = ({ switchToBuyTab }) => {
  const authCtx = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const transactionsPerPage = 10;


  useEffect(() => {
    const getTransactionHistory = async () => {
      try {
        const transactions = await fetchTransactionHistory(authCtx);
        console.log("API Response:", transactions);

        if (!Array.isArray(transactions) || transactions.length === 0) {
          console.error("Invalid API Response:", transactions);
          setError('No purchase history found');
          return;
        }

        const purchases = (transactions[0]?.purchases || []).filter(t => t.amount !== null);
        setData(purchases);
      } catch (err) {
        console.error("Fetch Error:", err);
        setError('Failed to fetch transaction history');
      } finally {
        setLoading(false);
      }
    };

    getTransactionHistory();
  }, [authCtx]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Success':
        return '#73B76F';
      case 'Pending':
        return '#EEC146';
      case 'Failed':
        return '#B6111F';
      default:
        return 'gray';
    }
  };

  const calculatedAmount = (token) => {

    let calculatedAmount;
    if (token < 21) {
      calculatedAmount = token * 50
    } else if (token <= 50) {
      calculatedAmount = token * 45
    } else {
      calculatedAmount = token * 40
    }

    return `$${calculatedAmount}`;;
  }

  const estimateTokensFromAmount = (amount) => {
    if (!amount) return 0;
    return amount / 45;
  };

  const pricePerToken = (transaction) => {
    let tokens = transaction?.token;
    const amount = transaction?.amount

    if(amount == 0 || transaction?.tokenAddedByAdmin === true || transaction?.tokenAddedByAdmin === "true") return 0

    if (tokens == null) {
      tokens = calculatedTokens(transaction);
      if (tokens === 'N/A') return 'N/A';
    }

    tokens = parseFloat(tokens);

    if (tokens > 50) return 40;
    if (tokens > 20) return 45;
    return 50;
  };

  const calculatedTokens = (transaction) => {
    if (transaction?.token != null) return transaction.token;

    const amount = parseFloat(transaction?.amount);
    if (isNaN(amount)) return 'N/A';

    let tokens = 0;

    const t40 = amount / 40;
    if (t40 > 50 && Number.isInteger(t40)) return t40;
    const t45 = amount / 45;
    if (t45 > 20 && t45 <= 50 && Number.isInteger(t45)) return t45;

    const t50 = amount / 50;
    if (t50 <= 20 && Number.isInteger(t50)) return t50;

    if (amount > 2295) return (amount / 40).toFixed(2);
    if (amount > 945) return (amount / 45).toFixed(2);
    return (amount / 50).toFixed(2);
  };

  if (loading) return <CircularProgress style={{ color: '##245775' }} size={40} />
  if (error) return <p>{error}</p>;
  // if (data?.length === 0) return <p>No transactions found.</p>;
  if (data === "unedfined") return <p>Undefined Data</p>

  const totalPages = Math.max(1, Math.ceil((data?.length || 0) / transactionsPerPage));
  const startIndex = (currentPage - 1) * transactionsPerPage;
  const endIndex = startIndex + transactionsPerPage;
  const visibleTransactions = data?.length ? data.slice(startIndex, endIndex) : [];
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString.replace(' ', 'T'));
    if (isNaN(date.getTime())) return 'N/A';

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month} ${day} ${year}`;
  };


  console.log("data", data)

  return (
    <div className="PurchaseHistory-table-container">
      {data.length > 0 ?
        <>
          <h2 className='PurchaseHistory-table-heading'>Purchase History</h2>
          <div className="PurchaseHistory-table">
            <div className="table-header">
              <div className="header-cell header-one">#</div>
              <div className="header-cell header-two">Date</div>
              <div className="header-cell header-three">Amount</div>
              <div className="header-cell header-four">Price per token</div>
              <div className="header-cell header-five">No. of Tokens</div>
              <div className="header-cell header-six">Status</div>
            </div>
            <div className="table-body">
              {visibleTransactions.map((transaction, index) => (
                <div key={index} className="table-row">
                  <div className="cell order-number one">{index + 1}</div>
                  <div className="cell client-name two">{formatDate(transaction?.createdAt)}</div>
                  <div className="cell three cell-style">${transaction?.amount || 'N/A'}</div>
                  <div className="cell four cell-style">${pricePerToken(transaction)}</div>
                  <div className="cell five cell-style">{Math.round(calculatedTokens(transaction))}</div>
                  <div className="cell six status-text">
                    {console.log("transaction", transaction)}
                    <div className="status" style={{ backgroundColor: getStatusColor(transaction?.status) }}></div>
                    {transaction?.status}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className='transactions-info'>
            Showing {Math.min(endIndex, data?.length)} of {data?.length} transactions
          </div>
          <div className='scroll-indicator-container'>
            <div className='scroll-left' onClick={handlePrevPage} style={{ opacity: currentPage === 1 ? 0.5 : 1 }}>
              <img src={scrollLeft} alt="Previous" />
            </div>
            {Array.from({ length: totalPages }).map((_, index) => (
              <div
                key={index}
                className={`indicator ${currentPage === index + 1 ? 'active' : ''}`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </div>
            ))}
            <div className='scroll-right' onClick={handleNextPage} style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}>
              <img src={scrollRight} alt="Next" />
            </div>
          </div>
        </>
        :
        <div className="addassessmentdetails">
          <p className="pform">Looks like you haven’t purchased any tokens yet.</p>
          <p className="pform">Let’s get you started—buy your first token now!</p>
          <Button className="cta-assessment" onClick={switchToBuyTab} >
            Buy Tokens
          </Button>
        </div>
      }
    </div>
  );
};

export default PurchaseHistory;